/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class IntegrationAlfrescoCloudApi extends BaseApi {
    confirmAuthorisation(code) {
        throwIfNotDefined(code, 'code');
        const queryParams = {
            code
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/confirm-auth-request',
            queryParams,
            accepts: ['text/html']
        });
    }
    getAllNetworks() {
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/networks'
        });
    }
    getAllSites(networkId) {
        throwIfNotDefined(networkId, 'networkId');
        const pathParams = {
            networkId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/networks/{networkId}/sites',
            pathParams
        });
    }
    getContentInFolderPath(networkId, opts) {
        throwIfNotDefined(networkId, 'networkId');
        const pathParams = {
            networkId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/networks/{networkId}/sites/{siteId}/folderpath/{folderPath}/content',
            pathParams,
            queryParams: opts
        });
    }
    getContentInFolder(networkId, folderId) {
        throwIfNotDefined(networkId, 'networkId');
        throwIfNotDefined(folderId, 'folderId');
        const pathParams = {
            networkId,
            folderId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/networks/{networkId}/folders/{folderId}/content',
            pathParams
        });
    }
    getContentInSite(networkId, siteId) {
        throwIfNotDefined(networkId, 'networkId');
        throwIfNotDefined(siteId, 'siteId');
        const pathParams = {
            networkId,
            siteId
        };
        return this.get({
            path: '/api/enterprise/integration/alfresco-cloud/networks/{networkId}/sites/{siteId}/content',
            pathParams
        });
    }
}
